import React, { useState, useEffect } from "react";
import Icon from "../../../Elements/Icon/Icon.tsx";
import Button from "../../../Elements/Button/Button.js";
import Tooltip from "../../../Elements/Tooltip/Tooltip.js";
import AdblockerModal from "components/Pages/Gallery/GalleryContent/AdblockerModal.js";
import useSelfRemovalLink from "hooks/useSelfRemovalLink.tsx";
import GlobalPopUp from "../../../Reusable/GlobalPopUp/GlobalPopUp.js";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { useModal } from "../../../../contexts/modalContext/modalContext.js";
import { useMailView } from "../../../../contexts/mailViewContext/mailViewContext.js";
import { useDownloadRequest } from "../../../../hooks/useDownloadRequest.js";
import { useAdblockerModal } from "hooks/useAdblockerModal.js";
import { ExternalNotification } from "./ExternalNotification.tsx";
import { useRecaptcha } from "../../../../contexts/recaptchaContext/recaptchaContext.js";
import { awaiter } from "components/Pages/Home/Helpers/helpers.js";
import { getLocalStorage } from "utils/globalLocalStorage.js";
import { RECAPTCHA_APPEAR_DELAY } from "utils/globalConsts.ts";

const DownloadButtonWrapper = ({ children }) => {
  const { getMailSecurity } = useMail();

  if (!getMailSecurity()?.previewFiles) {
    return <>{children}</>;
  } else {
    return (
      <Tooltip tooltipTextKey={"preview-only-download-button-tooltip"} start>
        {children}
      </Tooltip>
    );
  }
};

const DownloadComponent = ({ classNames, children }) => {
  const { getTextByKey, getRecaptchaRequired } = useContent();
  const { setModal } = useModal();
  const displayAdblockerPopUp = useAdblockerModal();

  const {
    getPaymentData,
    isMailAvailable,
    getIsDisplayAllowed,
    getMailMetaData,
    getMailSecurity,
  } = useMail();

  const { getFilesSelection } = useMailView();

  const isSelfRemove = useSelfRemovalLink();

  const isDisplayAllowed = isSelfRemove
    ? false
    : isMailAvailable()
    ? getPaymentData()
      ? true
      : getIsDisplayAllowed()
      ? true
      : false
    : false;

  const { handleDownload, isWaitingForResponse, isClicked } =
    useDownloadRequest({
      itemId: null,
    });
  const { setShowRecaptcha } = useRecaptcha();

  const [showNoti, setShowNoti] = useState(true);
  useEffect(() => {
    if (isClicked) {
    }
  }, [isClicked]);

  useEffect(() => {
    let element = document.getElementById("stuck-id");
    if (element !== null && element !== undefined && element.length > 0) {
      element[0].addEventListener(
        "click",
        () =>
          setModal(() => <GlobalPopUp text={"please-contact-support-bezek"} />),
        false
      );
    }
  });

  const startDownload = async (recaptchaResponse) => {
    if (displayAdblockerPopUp) {
      setModal(() => <AdblockerModal />);
    } else {
      if (!getMailSecurity()?.previewFiles) {
        if (!recaptchaResponse && getRecaptchaRequired()) {
          setShowRecaptcha("gallery", startDownload);
        } else {
          handleDownload(recaptchaResponse);
          setShowRecaptcha(false, "gallery");
        }
      }
    }
  };

  return (
    <>
      {isDisplayAllowed ? (
        <div
          className="flex-row download-section"
          onClick={() => {
            startDownload();
          }}
        >
          {getPaymentData() ? (
            <div className="jumbo-pay-icon">
              <Icon name="dollar-solid" orange large />
            </div>
          ) : null}
          <DownloadButtonWrapper>
            <Button
              small
              buttonClass={`${classNames} ${
                isWaitingForResponse || getMailSecurity()?.previewFiles
                  ? "disabled"
                  : ""
              }`}
            >
              {getTextByKey("download")}
              {children}
            </Button>
          </DownloadButtonWrapper>
          <ExternalNotification
            show={isWaitingForResponse && showNoti}
            setShow={setShowNoti}
            icon="zipper"
            title={getTextByKey("preparing-download-text")}
            message={getTextByKey("zipping-file-message").replace(
              "#filesnumber#",
              getFilesSelection().length > 0
                ? getFilesSelection().length
                : getMailMetaData().filesCount
            )}
          />
        </div>
      ) : null}
    </>
  );
};

export default DownloadComponent;
